<script>
    export let component;
</script>

<main class="flex justify-center px-16 py-6 bg-gray-200 md:col-span-4">
    <svelte:component this={component} />
</main>